/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vtp_Link_Error_Already_LinkedInputs */

const vi_vtp_link_error_already_linked = /** @type {(inputs: Vtp_Link_Error_Already_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vận đơn đã được gắn với một đơn hàng khác`)
};

/**

* @param {Vtp_Link_Error_Already_LinkedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vtp_link_error_already_linked = /** @type {((inputs?: Vtp_Link_Error_Already_LinkedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vtp_Link_Error_Already_LinkedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vtp_link_error_already_linked(inputs)
});